// Copia lato browser di backend/src/lib/codiceFiscale.ts: serve solo per l'avviso immediato mentre
// si scrive. La validazione che conta resta quella del server (stessa logica).
const VOCALI = 'AEIOU';
const OMOCODIA = 'LMNPQRSTUV';
const MESI = 'ABCDEHLMPRST';
const DISPARI = { 0:1,1:0,2:5,3:7,4:9,5:13,6:15,7:17,8:19,9:21,A:1,B:0,C:5,D:7,E:9,F:13,G:15,H:17,I:19,J:21,K:2,L:4,M:18,N:20,O:11,P:3,Q:6,R:8,S:12,T:14,U:16,V:10,W:22,X:25,Y:24,Z:23 };
const pari = (c) => (/\d/.test(c) ? +c : c.charCodeAt(0) - 65);
const lettere = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z]/g, '');
const cv = (s) => { const l = [...lettere(s)]; return { c: l.filter(x => !VOCALI.includes(x)), v: l.filter(x => VOCALI.includes(x)) }; };
const codCognome = (s) => { const { c, v } = cv(s); return (c.join('') + v.join('') + 'XXX').slice(0, 3); };
const codNome = (s) => { const { c, v } = cv(s); const k = c.length >= 4 ? [c[0], c[2], c[3]] : c; return (k.join('') + v.join('') + 'XXX').slice(0, 3); };

export const validaCF = (grezzo, nome, cognome) => {
  const cf = (grezzo || '').toUpperCase().replace(/\s+/g, '');
  if (!cf) return { valido: false, errore: 'Codice fiscale obbligatorio' };
  if (cf.length !== 16) return { valido: false, errore: `Il codice fiscale deve avere 16 caratteri (ne ha ${cf.length})` };
  const d = '[0-9LMNPQRSTUV]';
  if (!new RegExp(`^[A-Z]{6}${d}{2}[${MESI}]${d}{2}[A-Z]${d}{3}[A-Z]$`).test(cf)) return { valido: false, errore: 'Formato del codice fiscale non valido' };
  let somma = 0;
  for (let i = 0; i < 15; i++) somma += i % 2 === 0 ? DISPARI[cf[i]] : pari(cf[i]);
  if (String.fromCharCode(65 + (somma % 26)) !== cf[15]) return { valido: false, errore: 'Ultimo carattere di controllo errato: probabile errore di battitura' };
  if (nome && cognome) {
    if (codCognome(cognome) + codNome(nome) === cf.slice(0, 6)) return { valido: true, cf };
    const comeI = (t) => t.normalize('NFD').replace(/[jy]/gi, 'I'); // Jacchia/Iacchia: CF registrato con l'altra grafia
    if (codCognome(comeI(cognome)) + codNome(comeI(nome)) === cf.slice(0, 6)) return { valido: true, cf };
    if (codCognome(nome) + codNome(cognome) === cf.slice(0, 6) || codCognome(comeI(nome)) + codNome(comeI(cognome)) === cf.slice(0, 6)) return { valido: false, invertito: true, errore: 'Nome e cognome sembrano invertiti rispetto al codice fiscale' };
    return { valido: false, errore: 'Il codice fiscale non corrisponde a nome e cognome (se hai un secondo nome o un doppio cognome scrivili come sul documento)' };
  }
  // CF valido in sé, ma senza nome e cognome non si è ancora verificato che sia di questa persona
  return { valido: true, cf, parziale: true };
};

// 16 volte "A" = codice fiscale non disponibile adesso (solo staff: anagrafica, planning, import). La scheda
// nasce senza CF ed è segnalata CF DA INSERIRE. Registrazione e form pubblici non lo accettano.
export const CF_DA_INSERIRE = 'AAAAAAAAAAAAAAAA';
export const cfDaInserire = (v) => (v || '').replace(/\s+/g, '').toUpperCase() === CF_DA_INSERIRE;

// Open / Under 18 dal codice fiscale (14/10/2026, titolare: "quando metto il CF deve selezionarlo da solo").
// Stessa regola del server (categoriaDaNascita): età di oggi < 18 = UNDER18. null se il CF non è completo/valido.
export const categoriaDaCF = (grezzo) => {
  const cf = (grezzo || '').toUpperCase().replace(/\s+/g, '');
  if (cf.length !== 16 || cfDaInserire(cf) || !validaCF(cf).valido) return null;
  const cifra = (c) => (/\d/.test(c) ? c : String(OMOCODIA.indexOf(c)));
  const aa = +(cifra(cf[6]) + cifra(cf[7]));
  const mese = MESI.indexOf(cf[8]);
  const gg = +(cifra(cf[9]) + cifra(cf[10])) % 40;
  const anno = aa > new Date().getFullYear() % 100 ? 1900 + aa : 2000 + aa;
  const oggi = new Date();
  const eta = oggi.getFullYear() - anno - (oggi < new Date(oggi.getFullYear(), mese, gg) ? 1 : 0);
  return eta < 18 ? 'UNDER18' : 'OPEN';
};
